function handleStandardTurning(event, page, view) {
  const windowWidth = $(window).width();
  if (page === 1) {
    $('#MainContent').css('margin-left', windowWidth > 1400 ? '-375px' : '-300px');
    $('body').removeClass('flip-book-black-bg');
  } else {
    $('#clonedPopover').hide();
    $('#MainContent').css('margin-left', 'unset');
    $('body').addClass('flip-book-black-bg');
  }
}

function handleStandardTurned(event, page, view) {
  let newUrl = '';
  $('.main-nav .menu-item div').removeClass('active');
  if (page === 1) {
    $('.main-nav .menu-item div[data-id="page-home-link"]').addClass('active');
    newUrl = '/';
  }
  if (page === 2 || page === 3) {
    $('.main-nav .menu-item div[data-id="page-lookbook-link"]').addClass('active');
    newUrl = '/pages/lookbook';
  }
  if (page === 4) {
    $('.main-nav .menu-item div[data-id="page-mot-link"]').addClass('active');
    newUrl = '/pages/mot';
  }
  if (page === 6) {
    $('.main-nav .menu-item div[data-id="page-campaign-link"]').addClass('active');
    newUrl = '/pages/campaign';
  }
  if (newUrl) {
    history.pushState({ page: page }, '', newUrl);
  }

    if ($('.masonry-grid')) {
    var $container = $('.masonry-grid').masonry({
       itemSelector: "img",
       columnWidth: ".grid-sizer",
       gutter: 20,
       percentPosition: true      
    });

   $container.imagesLoaded().progress( function() {
        $container.masonry('layout');
   });
  }
}

function getStandardFlipbookEvents() {
  return {
    turning: handleStandardTurning,
    turned: handleStandardTurned,
  };
}

function initializeFlipbookSize() {
  const windowWidth = $(window).width();
  const windowHeight = $(window).height();
  let flipbookWidth, flipbookHeight;

  if (windowWidth >= 1023 && windowWidth <= 1300) {
    flipbookWidth = 1072;
    flipbookHeight = 660;
  } else if (windowWidth >= 1300 && windowWidth <= 1400) {
    flipbookWidth = 1272;
    flipbookHeight = 780;
  } else if (windowWidth > 1400) {
    flipbookWidth = 1472;
    flipbookHeight = 880;
  }

  if (windowHeight < flipbookHeight) {
    const aspectRatio = flipbookWidth / flipbookHeight;
    flipbookHeight = windowHeight - 100;
    flipbookWidth = flipbookHeight * aspectRatio;
  }

  return { flipbookWidth, flipbookHeight };
}

function destroyFlipbook(selector) {
  if ($(selector).data('turn')) {
    $(selector).turn('destroy');
    $(selector).hide();
  }
}

let savedCoverDimensions = null;

function resizeCoverPage() {
  const windowWidth = $(window).width();
  const windowHeight = $(window).height();

  if (windowWidth <= 1023) {
    const aspectRatio = 756 / 900;
    const coverPageWidth = windowWidth - 20;
    const coverPageHeight = windowHeight - 100;

    if ((coverPageWidth / coverPageHeight) > aspectRatio) {
      const newWidth = coverPageHeight * aspectRatio;
      const newHeight = coverPageHeight;
      
      savedCoverDimensions = { width: newWidth, height: newHeight };

      $('#mobile-layout .mag-cover, #mobile-layout .homepage-cover').css({
        width: newWidth,
        height: newHeight
      });
    } else {
      $('#mobile-layout .mag-cover, #mobile-layout .homepage-cover').css({
          width: coverPageWidth,
          height: coverPageWidth / aspectRatio
        });
    }
  }
}

function calculatePortraitSizeFromLandscape() {
  const windowWidth = $(window).width();
  const windowHeight = $(window).height();
  const aspectRatio = 756 / 900;

  // Use landscape width and height to calculate portrait-size cover
  const coverPageWidth = windowHeight - 20;
  const coverPageHeight = windowWidth - 100;

  if ((coverPageWidth / coverPageHeight) > aspectRatio) {
    return {
      width: coverPageHeight * aspectRatio,
      height: coverPageHeight
    };
  } else {
    return {
      width: coverPageWidth,
      height: coverPageWidth / aspectRatio
    };
  }
}

function applySavedDimensions() {
  if (savedCoverDimensions) {
    $('#mobile-layout .mag-cover, #mobile-layout .homepage-cover').css({
      width: savedCoverDimensions.width,
      height: savedCoverDimensions.height
    });
  }
}

function showFlipbookWhenReady(selector) {
  requestAnimationFrame(function checkFlipbook() {
    if ($(selector).turn('page') > 0) {
      $(selector).css({
        visibility: 'visible',
        opacity: '1',
      });
    } else {
      requestAnimationFrame(checkFlipbook);
    }
  });
}

function setupFlipbookEvents(selector) {
  $(selector).on('start', function (event, pageObject, corner) {
    if (pageObject.page === 1 && ['tl', 'tr', 'bl'].includes(corner)) {
      event.preventDefault();
    } else if (corner === 'l') {
      event.preventDefault();
    }
    $(selector)
      .removeClass('grabbing notgrab')
      .addClass(corner ? 'grab' : 'notgrab');
  });

  $(selector).on('mousedown touchstart', function () {
    if ($(selector).hasClass('grab')) {
      $(selector).removeClass('grab notgrab').addClass('grabbing');
    }
  });

  $(selector).on('mouseup touchend end', function () {
    $(selector).removeClass('grabbing grab').addClass('notgrab');
  });

  $(selector).on('touchmove', function (event) {
    event.preventDefault();
  });

  $(selector).on('turning', function () {
    const audio = $('#flipSound')[0];
    audio.play().catch(function (error) {
      console.log('Autoplay blocked. Waiting for user interaction.');
    });
  });
}

function getInitialPageByUrlPath() {
  const urlPath = window.location.pathname;

  function setFlipbookPosition() {
    $('#clonedPopover').hide();
    $('#MainContent').css('margin-left', 'unset');
    $('body').addClass('flip-book-black-bg');
  }
  
  if (urlPath === '/pages/lookbook') {
    $('.main-nav .menu-item div[data-id="page-lookbook-link"]').addClass('active');
    setFlipbookPosition();
    return 2;
  } else if (urlPath === '/pages/mot') {
    $('.main-nav .menu-item div[data-id="page-mot-link"]').addClass('active');
    setFlipbookPosition();
    return 4;
  } else if (urlPath === '/pages/campaign') {
    $('.main-nav .menu-item div[data-id="page-campaign-link"]').addClass('active');
    setFlipbookPosition();
    return 6;
  } else {
    return 1;
     $('.main-nav .menu-item div[data-id="page-home-link"]').addClass('active');
     $('#MainContent').css('margin-left', windowWidth > 1400 ? '-375px' : '-300px');
     $('body').removeClass('flip-book-black-bg');
  }
}

function initStandardFlipbook() {
  const flipbookSelector = '#flipbook';
  const $flipbook = $(flipbookSelector);

  if ($flipbook.length === 0) {
    return; 
  }
  
  if ($(window).width() <= 1023 && $flipbook.data('turn')) {
    destroyFlipbook(flipbookSelector);
    return;
  }

  const { flipbookWidth, flipbookHeight } = initializeFlipbookSize();
  $flipbook.turn({
    width: flipbookWidth,
    height: flipbookHeight,
    autoCenter: false,
    gradients: true,
    acceleration: true,
    elevation: 50,
    duration: 1000,
    smartFlip: true,
    autoScaleContent: true,
    page: getInitialPageByUrlPath(),
    when: getStandardFlipbookEvents()
  });

  setupFlipbookEvents(flipbookSelector);
  showFlipbookWhenReady(flipbookSelector);
}

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
   $('.page-link')
      .filter(`[data-page="${parseInt(urlParams.get(param)) || 1}"]`) 
      .addClass('active'); 
  return parseInt(urlParams.get(param)) || 1;
}

function getPhysicalPage(paginationNumber) {
  return (paginationNumber - 1) * 2 + 2;
}

function initShopFlipbook() {
  const flipbookSelector = '#shop-flipbook';
  const $flipbook = $(flipbookSelector);

  if ($flipbook.length === 0) {
    return; 
  }

  if ($(window).width() <= 1023 && $flipbook.data('turn')) {
    destroyFlipbook(flipbookSelector);
    return;
  }

  const { flipbookWidth, flipbookHeight } = initializeFlipbookSize();
   const queryPage = getQueryParam('page');
  const initialPage = queryPage === 1 ? 1 : getPhysicalPage(queryPage);
  
  $flipbook.turn({
    width: flipbookWidth,
    height: flipbookHeight,
    autoCenter: false,
    gradients: true,
    acceleration: true,
    elevation: 50,
    duration: 1000,
    smartFlip: true,
    autoScaleContent: true,
    page: initialPage,
  });

  $flipbook.on('turning', function (event, page) {
    if (page === 1) {
      event.preventDefault();
    }
  });

  if (queryPage === 1) {
    setTimeout(() => {
      $flipbook.turn('page', 2);
    }, 300); 
  }

  $flipbook.on('turned', function (event, page) {
    if (page === 1) {
      $flipbook.turn('page', 2);
    }
  });

  $('.page-link').on('click', function (e) {
    e.preventDefault();
    const targetPage = parseInt($(this).data('page'));

    const newUrl = new URL(window.location);
    newUrl.searchParams.set('page', targetPage);
    window.history.pushState({}, '', newUrl);

    const physicalPage = getPhysicalPage(targetPage);
    $flipbook.turn('page', physicalPage);
    $('.page-link')
      .removeClass('active')
      .filter(`[data-page="${targetPage}"]`) 
      .addClass('active'); 
  });

  setupFlipbookEvents(flipbookSelector);
  showFlipbookWhenReady(flipbookSelector);
}

function initProductFlipbook() {
  const flipbookSelector = '#product-flipbook';
  const $flipbook = $(flipbookSelector);

  if ($flipbook.length === 0) {
    return; 
  }

  if ($(window).width() <= 1023 && $flipbook.data('turn')) {
    destroyFlipbook(flipbookSelector);
    return;
  }

  const { flipbookWidth, flipbookHeight } = initializeFlipbookSize();
  
  $flipbook.turn({
    width: flipbookWidth,
    height: flipbookHeight,
    autoCenter: false,
    gradients: true,
    acceleration: true,
    elevation: 50,
    duration: 1000,
    smartFlip: true,
    autoScaleContent: true,
    page: 1,
  });

  $flipbook.on('turning', function (event, page) { 
    if (page === 1) {
      event.preventDefault();
    }
  });

   setTimeout(() => {
      $flipbook.turn('page', 2);
    }, 300);

  $flipbook.on('turned', function (event, page) {
    if (page === 1) {
      $flipbook.turn('page', 2);
    }
  });

  setupFlipbookEvents(flipbookSelector);
  showFlipbookWhenReady(flipbookSelector);
}

$(document).ready(function() {
  if ($(window).width() >= 1023) {
    initStandardFlipbook();
    initShopFlipbook();
    initProductFlipbook();
  }

  function handleResize() {
    if ($(window).width() <= 1023 && $(window).width() < $(window).height()) {   
        resizeCoverPage();
    } else if ($(window).width() <= 1023 && $(window).width() > $(window).height()) {
      // Landscape mode
      if (!savedCoverDimensions) {
          // Calculate and save dimensions based on landscape mode for portrait sizing
          savedCoverDimensions = calculatePortraitSizeFromLandscape();
        }
        applySavedDimensions();
    } else {
      if ($('.page-wrapper').length < 1) {
        initStandardFlipbook();
        initShopFlipbook();
        initProductFlipbook();
      }
    }
  }

  if ($(window).width() <= 1023 && $(window).width() > $(window).height()) {
    // On initial load, if in landscape mode and screen width <= 1023
    savedCoverDimensions = calculatePortraitSizeFromLandscape();
    applySavedDimensions();
  } else if ($(window).width() <= 1023) {
    // On initial load, if in portrait mode and screen width <= 1023
    resizeCoverPage();
  }

  function resizeFlipbook() {
    const { flipbookWidth, flipbookHeight } = initializeFlipbookSize();
    $('.flipbook-wrapper').turn('size', flipbookWidth, flipbookHeight);
  }

  $(window).on('resize', function() {
    handleResize();
    if ($(window).width() > 1023) {   
      resizeFlipbook();
    }
  });
});
